export type CategoryTypes = {
    records: boolean;
    stories: boolean;
    trees: boolean;
    photos: boolean;
};

export const TYPE_TO_LETTER_MAPPING = {
    records: "r",
    stories: "s",
    trees: "t",
    photos: "p",
} as const;

export const LETTER_TO_TYPE_MAPPING: Record<string, keyof CategoryTypes> = {
    r: "records",
    s: "stories",
    t: "trees",
    p: "photos",
};

export const convertTypesToLetters = (types: CategoryTypes): string =>
    Object.entries(types)
        .filter(([, isSelected]) => isSelected)
        .map(([typeKey]) => TYPE_TO_LETTER_MAPPING[typeKey as keyof typeof TYPE_TO_LETTER_MAPPING])
        .join("");

export const convertLettersToTypes = (letters: string): CategoryTypes => {
    const types: CategoryTypes = { records: false, stories: false, trees: false, photos: false };
    for (const letter of letters.toLowerCase()) {
        const typeKey = LETTER_TO_TYPE_MAPPING[letter];
        if (typeKey) types[typeKey] = true;
    }
    return types;
};
